import { render, staticRenderFns } from "./addSearchConfig.vue?vue&type=template&id=86283ba6&scoped=true"
import script from "./addSearchConfig.vue?vue&type=script&lang=js"
export * from "./addSearchConfig.vue?vue&type=script&lang=js"
import style0 from "./addSearchConfig.vue?vue&type=style&index=0&id=86283ba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86283ba6",
  null
  
)

export default component.exports